export const iconFontAwesomeDevicesHardwareHeadphones = (
	<i className="fa-solid fa-headphones"></i>
);
